<template>
  <div class="home-content-page-v">
    <div class="content-one">
      <content-title :title="'数据导入'"></content-title>
      <div class="output-content">
        <div class="output-content-1">
          <div class="checkbox-content">
            <div v-if="isAdmin" style="margin-bottom: 2rem;">
              <span style="color: #666;margin-right: 0.5rem;line-height: 2rem;">全部配送中心</span>
               <el-switch v-model="allPs"></el-switch>
            </div>
            <el-select v-model="dataType" filterable placeholder="请选择文件类型">
              <el-option v-for="item in dataTypes" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
            <div class="input-date">导入数据时间:{{inputDate}}</div>
            <input type="file" :disabled="!canInput" @change="fileChange" :id="fileId">
          </div>
        </div>
        <div class="output-content-2">
          <div class="data-one" @click="inputDate = item['日期']; chooseHis=item" v-for="item in hisData">{{item['日期'] + ': ' + item['TOTAL']}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  readExcelFileData
} from '@/cllib'
import {
  inputAllData
} from '@/api/oli_api'
import ContentTitle from '@/components_bit/ContentTitle'
export default {
  data () {
    return {
      allPs: false,
      dataType: null,
      fileId: 'file-input',
      hisData: [],
      chooseHis: {},
      inputDate: ''
    }
  },
  components: {
    ContentTitle
  },
  computed: {
    isAdmin: {
      get () {
        console.log(this.$store.getters.userInfo)
        return this.$store.getters.userInfo && this.$store.getters.userInfo.USER_ACCOUNT === 'miiro'
      }
    },
    dataTypes: {
      get () {
        let data = []
        if (this.isAdmin) {
          data = ['当日有实际出库的配送计划', '按ERP出库时间导入配送计划', 'driver', 'driver_black', 'car_zz', 'update_oil_name']
        }
        return data
      }
    },
    canInput: {
      get () {
        return true
      }
    }
  },
  watch: {
    allPs (value) {
      this.loadData(this.dataType)
    },
    dataType (value) {
      this.loadData(value)
    }
  },
  methods: {
    loadData (type) {
      this.inputDate = ''
      this.hisData = []
      this.chooseHis = {}
      if (type === '进销存') {
        this.loadJxcInputData()
      } else if (type === '配送计划') {
        this.loadPsjhInputData()
      }
    },
    loadJxcInputData () {
      inputAllData({action: 'get_jxc_input_data', data: {dayNum: 10, allPs: this.allPs ? 1 : 0}}).then((data) => {
        this.hisData = data
      })
    },
    loadPsjhInputData () {
      inputAllData({action: 'get_ps_input_data', data: {dayNum: 10, allPs: this.allPs ? 1 : 0}}).then((data) => {
        this.hisData = data
      })
    },
    checkFile (files) {
      if (!files.length) {
        return null
      } else if (['xlsx', 'xls'].indexOf(files[0].name.split('.').slice(-1)[0]) > -1) {
        return files[0]
      } else {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请选择excel文件。'
        })
        return false
      }
    },
    fileChange (e) {
      let fileInput = this.checkFile(e.target.files || e.dataTransfer.files)
      if (!fileInput) {
        document.getElementById(this.fileId).value = ''
      } else {
        if (this.dataType === 'driver') {
          this.inputDriverData(fileInput)
        } else if (this.dataType === 'driver_black') {
          this.inputDriverBlackData(fileInput)
        } else if (this.dataType === 'car_zz') {
          this.inputCarZZ(fileInput)
        } else if (this.dataType === '当日有实际出库的配送计划') {
          this.inputPsSjData(fileInput)
        } else if (this.dataType === '按ERP出库时间导入配送计划') {
          this.inputCJSJData(fileInput)
        } else if (this.dataType === 'update_oil_name') {
          this.inputOilNameUpdate(fileInput)
        }
        document.getElementById(this.fileId).value = ''
      }
    },
    inputPsData (fileInput) {
      this.$store.dispatch('inputOlderPlan', {excelFile: fileInput, fileId: this.fileId, date: this.inputDate})
    },
    inputPsSjData (fileInput) {
      this.$store.dispatch('inputOlderPlan', {excelFile: fileInput, fileId: this.fileId, realData: 1})
    },
    inputCJSJData (fileInput) {
      this.$store.dispatch('inputOlderPlan', {excelFile: fileInput, fileId: this.fileId, realData: 2})
    },
    inputJxcData (fileInput) {
      this.$store.dispatch('dealJxcExceldata', {excelFile: fileInput, fileId: this.fileId, date: this.inputDate})
    },
    inputDriverData (excelFile) {
      let sheets = [{
        needDataKeys: ['承运商名称', '所属车队', '人员代码', '姓名', '联系电话', '工种', '人员状态', '身份证号码', '机动车驾驶证号']
      }]
      let dispatch = this.$store.dispatch
      readExcelFileData({file: excelFile, sheets, allsheets: true, type: 'row_object_array'}).then(function (data) {
        let allData = []
        for (let key in data) {
          data[key].forEach(function (item) {
            allData.push(item)
          })
        }
        inputAllData({action: 'driver', data: allData}).then((data) => {
          if (data['code'] !== '-1') {
            dispatch('showNoticeMsg', {
              type: 'info',
              title: '系统提示',
              message: '文件导入成功'
            })
          } else {
            throw new Error('error')
          }
        })
      }).catch((e) => {
        dispatch('showNoticeMsg', {
          type: 'error',
          title: '导入文件解析失败',
          message: '请检查文件格式是否符合导入规则'
        })
        document.getElementById(this.fileId).value = ''
        console.log(e)
      })
    },
    inputDriverBlackData (excelFile) {
      let sheets = [{
        needDataKeys: ['姓名', '身份证号', '岗位', '违规记录']
      }]
      let dispatch = this.$store.dispatch
      readExcelFileData({file: excelFile, sheets, allsheets: true, type: 'row_object_array'}).then(function (data) {
        let allData = []
        for (let key in data) {
          data[key].forEach(function (item) {
            allData.push(item)
          })
        }
        inputAllData({action: 'driver_black', data: allData}).then((data) => {
          if (data['code'] !== '-1') {
            dispatch('showNoticeMsg', {
              type: 'info',
              title: '系统提示',
              message: '文件导入成功'
            })
          } else {
            throw new Error('error')
          }
        })
      }).catch((e) => {
        dispatch('showNoticeMsg', {
          type: 'error',
          title: '导入文件解析失败',
          message: '请检查文件格式是否符合导入规则'
        })
        document.getElementById(this.fileId).value = ''
        console.log(e)
      })
    },
    inputOilNameUpdate (excelFile) {
      // 更新加油站名称
      let sheets = [{
        needDataKeys: ['加油站代码', '加油名称']
      }]
      let dispatch = this.$store.dispatch
      readExcelFileData({file: excelFile, sheets, allsheets: true, type: 'row_object_array'}).then(function (data) {
        let allData = []
        for (let key in data) {
          data[key].forEach(function (item) {
            allData.push(item)
          })
        }
        inputAllData({action: 'update_oil_name', data: allData}).then((data) => {
          if (data['code'] !== '-1') {
            dispatch('showNoticeMsg', {
              type: 'info',
              title: '系统提示',
              message: '文件导入成功'
            })
          } else {
            throw new Error('error')
          }
        })
      }).catch((e) => {
        dispatch('showNoticeMsg', {
          type: 'error',
          title: '导入文件解析失败',
          message: '请检查文件格式是否符合导入规则'
        })
        document.getElementById(this.fileId).value = ''
        console.log(e)
      })
    },
    inputCarZZ (excelFile) {
      let sheets = [{
        needDataKeys: ['车牌号', '车辆类型', '牵引车号', '驾驶员']
      }]
      let dispatch = this.$store.dispatch
      readExcelFileData({file: excelFile, sheets, allsheets: true, type: 'row_object_array'}).then(function (data) {
        let allData = []
        for (let key in data) {
          data[key].forEach(function (item) {
            allData.push(item)
          })
        }
        inputAllData({action: 'car_zz', data: allData}).then((data) => {
          if (data['code'] !== '-1') {
            dispatch('showNoticeMsg', {
              type: 'info',
              title: '系统提示',
              message: '文件导入成功'
            })
          } else {
            throw new Error('error')
          }
        })
      }).catch((e) => {
        dispatch('showNoticeMsg', {
          type: 'error',
          title: '导入文件解析失败',
          message: '请检查文件格式是否符合导入规则'
        })
        document.getElementById(this.fileId).value = ''
        console.log(e)
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '../../style/base.less';
.input-date {
  font-size: 1rem;
  color: #666;
  margin-top: 2rem;
}
.input-note-info {
  flex: 1;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  color: #999;
}
.content-one {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-bottom: 2em;
}
.output-btn {
  align-self: flex-end;
  color:#fff;
  background-color: @bak-color-2;
  padding: 0.5em 1.5em;
  text-align: center;
  border-radius: 0.3em;
  letter-spacing: 0.1em;
}
.output-content-2 {
  flex: 4;
  display: flex;
  flex-wrap: wrap;
  padding: 1rem;
  justify-content: space-between;
}
.output-content {
  flex:1;
  .content-shadow;
  .content-bottom-radius;
  display: flex;
  padding: 2em;
  min-height: 22em;
  background-color: #fff;
}
.checkbox-label {
  .output-btn {
    margin-left: 3em;
  }
}
.btm-btn {
  margin: 1em 0 0 2em;
}
.m-line {
  width: 2px;
  background-color: #ccc;
  margin: 1.5em 2.2em 1.5em 0;
}
.output-content-1 {
  flex: 1;
  padding: 1em 2.5em 1em;
  margin-right: 1rem;
  display: flex;
  flex-direction: column;
  border-right: 0.2rem solid #ddd;
}
.data-one {
  width: 23%;
  height: 3rem;
  background-color: #0b5591;
  border-radius: 0.3rem;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.checkbox-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  .iconfont {
    margin-left: 1rem;
  }
  .error-iconfont {
    color: @color-warning;
  }
  .suc-iconfont {
    line-height: 1;
    color: @color-suc;
  }
  span {
    line-height: 1;
    font-size: 1.13em;
    padding-bottom: 0.5em;
    color: @bak-color-2;
  }
  input {
    margin-top: 2rem;
  }
}

.checkbox-one {
  display: flex;
  align-items: center;
  height: 3.4em;
  font-size: 1em;
  color:@bak-color-1;
  img {
    padding-right: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// input_data.vue?9d10309a